import { isEbayInvalidMarketplace } from '../shops';

import { EBAY, FAIRE } from '../../constants/channels';
import { FEATURE } from '../../constants/features';

export function canConnectShop({ connectedShops, user, userShops }) {
  return function canConnect(shopId) {
    if (!userShops.hasIn(['byId', shopId]) || connectedShops.includes(shopId)) return false;

    const channel = userShops.getIn(['byId', shopId, 'channel']);

    switch (channel) {
      case EBAY: {
        if (isEbayInvalidMarketplace(userShops.getIn(['byId', shopId, 'syncStatus']))) {
          return false;
        }

        break;
      }

      case FAIRE: {
        if (!user.getIn(['features', FEATURE.FAIRE_INTEGRATION])) {
          return false;
        }

        break;
      }

      default: {
        break;
      }
    }

    return true;
  };
}
